import { DateTime } from 'luxon';
import { BehaviorSubject } from 'rxjs';
import { ExamDayFilter } from '../../db/filter/examday-filter.js';

// Provides a globally callable Store in the form of a BehaviourSubject,
// which is an Observable with an initial value
export const examDayListFilter = new BehaviorSubject<ExamDayFilter>(
  new ExamDayFilter({
    year: DateTime.now().year,
    months: [],
    // isPlanned: null,
    isPublished: null,
    isPublishedForTesters: null,
    hasFallbackTesters: null,
    // hasSupervisor: null,
    hasCandidates: null,
  }),
);
